import io from 'socket.io-client';
import TokenService from './services/token.service';
import store from './store';
import { addNewMessage } from './store/reducers/Chat/slice';
import { setNeedUpdateGuild } from './store/reducers/Guild/slice';
import { addNewNotification, NOTIFICATION_TYPE } from './store/reducers/Notifications/slice';
import { refreshToken } from './store/reducers/Wallet/slice';
import * as log from './utils/log';
const baseUrl = process.env.REACT_APP_SOCKET_BACKEND_URL;

export let socket;

export function ioClient() {
    log.debug('client socket init');
    const server = baseUrl;
    const accessToken = TokenService.getWalletAccessToken();
    socket = io(`${server}/notification`, {
        query: {
            token: accessToken
        },
        path: '/ws/socket.io',
        reconnection: 5000
    });
    log.debug('socket1', socket);

    socket.on('connect', () => {
        log.debug('client connected');
    });

    socket.on('disconnect', (err) => {
        log.debug('disconnect: ', err);
    });

    socket.on('chat', (data) => {
        log.debug({ data });
        store.dispatch(addNewMessage(JSON.parse(data)));
    });

    socket.on('notification', (data) => {
        const notification = JSON.parse(data);
        store.dispatch(addNewNotification(notification));
        if (
            notification.type === NOTIFICATION_TYPE.GUILD_ANSWER ||
            notification.type === NOTIFICATION_TYPE.GUILD_ACTION ||
            notification.type === NOTIFICATION_TYPE.USER_ACTION
        ) {
            store.dispatch(setNeedUpdateGuild());
        }
    });

    socket.on('connect_error', (err) => {
        log.error('connect_error: ', err);
        if (err.message === 'unauthorized') {
            store.dispatch(refreshToken(TokenService.getWalletRefreshToken()));
        }
    });
}
